import { useCallback } from 'react';
import { rage } from '~/rage';
import { IModalReplyDefault, ModalButtonColor, ModalType } from '~/shared';

const useResetTuning = () => {
	const confirmReset = useCallback(() => {
		rage.modal.showModal(
			{
				type: ModalType.Default,
				title: 'Сброс в сток',
				text: 'При сбросе автомобиля в сток, весь ваш тюнинг с автомобиля будет удалён. Продолжить?',
				acceptButton: {
					text: 'Сбросить',
					color: ModalButtonColor.Danger,
				},
				cancelButton: {
					text: 'Отменить',
					color: ModalButtonColor.Secondary,
				},
			},
			(result: IModalReplyDefault) => {
				if (result.isAccepted) {
					rage.vehicleTuningShop.resetTuning().catch(() => {});
				}
			},
		);
	}, []);

	return { confirmReset };
};

export { useResetTuning };
